import { createApi } from "@reduxjs/toolkit/query/react";
import { createBaseQueryWithReauth } from "../utilities/refreshTokenUtility";

export const institutionCourseApi = createApi({
  reducerPath: "institutionCourseApi",
  
  baseQuery: createBaseQueryWithReauth(`${import.meta.env.VITE_BASE_API_URL}InstitutionCourse/`),

  endpoints: (builder) => ({
    getByInstitutionId: builder.query({
      query: (id) => ({
        url: `GetByInstitutionId?institutionId=${id}`,
        method: "GET",
      }),
    }),

    getInstitutionCourseById: builder.query({
      query: (id) => ({
        url: `GetInstitutionCourseById?id=${id}`,
        method: "GET",
      }),
    }),

    addInstitutionCourse: builder.mutation({
      query: (body) => {
        return {
          url: "AddInstitutionCourse",
          method: "POST",
          body,
        };
      },
    }),

    updateInstitutionCourse: builder.mutation({
      query: ( body ) => {
        return {
          url: "UpdateInstitutionCourse",
          method: "PUT",
          body,
        };
      },
    }),
    deleteInstitutionCourse: builder.mutation({
      query: id => ({
        url: `DeleteInstitutionCourse?id=${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useGetByInstitutionIdQuery,
  useGetInstitutionCourseByIdQuery,
  useAddInstitutionCourseMutation,
  useUpdateInstitutionCourseMutation,
  useDeleteInstitutionCourseMutation,
} = institutionCourseApi;

export default institutionCourseApi.reducer;
